import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import referralApi from '../../services/referralApi';

// /Referral/Me'yi tek noktadan çeker; layout ve referral sayfası paylaşır.
// `force` verilmedikçe zaten yüklenmiş/yükleniyorsa çağrı atlanır (dedup).
export const fetchReferralMe = createAsyncThunk(
  'referral/fetchMe',
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await referralApi.me();
      return res.data?.data || null;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || 'Failed to load referral data',
      );
    }
  },
  {
    condition: (arg, { getState }) => {
      const { referralReducer } = getState();
      if (arg?.force) return true;
      return !referralReducer.loading && !referralReducer.loaded;
    },
  },
);

const initialState = {
  data: null,
  loading: false,
  loaded: false,
  error: null,
};

export const referralSlice = createSlice({
  name: 'referral',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralMe.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralMe.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.loaded = true;
        state.data = payload;
      })
      .addCase(fetchReferralMe.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || 'Failed to load referral data';
      });
  },
});

export default referralSlice.reducer;
